import { Fragment, useState } from "react";
import { imgSrc } from "../lib/util";

export function Thumb({ r, lazy = false, children }) {
  const [failed, setFailed] = useState(false);
  const src = imgSrc(r);
  return (
    <div className={`th t-${r.kind}`}>
      <span aria-hidden="true">{r.emoji}</span>
      {src && !failed && <img src={src} alt={r.title} loading={lazy ? "lazy" : undefined} onError={() => setFailed(true)} data-testid={`recipe-photo-${r.slug}`} />}
      {children}
    </div>
  );
}

export function Card({ r, hidden, style }) {
  const search = (r.title + " " + r.tags.join(" ") + " " + r.ingredients.map(i => i.name).join(" ")).toLowerCase();
  return (
    <a className="rc" href={`/opskrifter/${r.slug}/`} data-title={r.title.toLowerCase()} data-time={r.time} data-price={r.price}
      data-tags={r.tags.join(",")} data-search={search} hidden={hidden} style={style} data-testid={`recipe-card-${r.slug}`}>
      <Thumb key={r.slug} r={r} lazy><div className="sticker"><b>{r.price}</b><small>kr.</small></div></Thumb>
      <div className="b"><h3>{r.title}</h3><div className="meta"><span>{`${r.time} min`}</span><span>{r.diff}</span>
        {r.rating_avg != null && <span className="rcard" data-testid={`card-rating-${r.slug}`} aria-label={`${r.rating_avg} ud af 5, ${r.rating_count} bedømmelser`}>★ {r.rating_avg.toFixed(1).replace(".", ",")} ({r.rating_count})</span>}</div></div>
    </a>
  );
}

export const Cards = ({ rs }) => <div className="grid">{rs.map(r => <Card key={r.slug} r={r} />)}</div>;

export function Crumbs({ trail }) {
  const parts = [<a key="f" href="/">Forside</a>];
  trail.forEach(([href, name], i) => {
    parts.push(<span key={"s" + i}>/</span>);
    parts.push(href ? <a key={"c" + i} href={"/" + href}>{name}</a> : <Fragment key={"c" + i}>{name}</Fragment>);
  });
  return <nav className="crumbs wrap" aria-label="Brødkrumme" data-testid="breadcrumbs">{parts}</nav>;
}

export const SectionHead = ({ title, href, more = "Se alle" }) => (
  <div className="sh"><h2>{title}</h2>{href && <a href={href}>{more}</a>}</div>
);

export const ToolCards = ({ tools }) => (
  <div className="tools">{tools.map(t => (
    <a key={t[0]} className="tc" href={`/vaerktoejer/${t[0]}/`} data-testid={`tool-card-${t[0]}`}><span className="i" aria-hidden="true">{t[2]}</span><h3>{t[1]}</h3><p>{t[3]}</p></a>
  ))}</div>
);

export const GuideCards = ({ gs }) => (
  <div className="glist">{gs.map(g => (
    <a key={g.slug} className="gc" href={`/guides/${g.slug}/`} data-testid={`guide-card-${g.slug}`}><span className="i" aria-hidden="true">{g.emoji}</span><div><h3>{g.title}</h3><p>{g.desc}</p></div></a>
  ))}</div>
);

export const Cta = ({ h, p }) => (
  <div className="cta"><div><h2>{h}</h2><p>{p}</p></div><a className="btn" href="/madplan/" data-testid="cta-madplan-link">Lav madplan</a></div>
);
